import { render, staticRenderFns } from "./ProfileWebsite.vue?vue&type=template&id=d4b0abf0"
import script from "./ProfileWebsite.vue?vue&type=script&lang=ts"
export * from "./ProfileWebsite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b0abf0')) {
      api.createRecord('d4b0abf0', component.options)
    } else {
      api.reload('d4b0abf0', component.options)
    }
    module.hot.accept("./ProfileWebsite.vue?vue&type=template&id=d4b0abf0", function () {
      api.rerender('d4b0abf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/ProfileWebsite.vue"
export default component.exports